import React from 'react';
import {render} from 'react-dom';
import {getPropsJson} from './';

export const mountReact = <P extends object>(
  selector: string,
  Component: React.ComponentType<P>,
) => {
  const target = document.querySelector(selector);

  if (!target) {
    return;
  }

  const props = getPropsJson(target);

  render(<Component {...props as P} />, target);
};
